import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../Guards/AuthGuard';
import { DeliveryPrincipalComponent } from './delivery/principal/delivery-principal.component';
import { DevolutionAddComponent } from './devolutions/devolution-add/devolution-add.component';
import { DeliveryRequestTransferComponent } from './delivery/request/delivery-request-transfer.component';

const routes: Routes = [
  { path: '', component: DeliveryPrincipalComponent, canActivate: [AuthGuard] },
  { path: 'devolution', component: DevolutionAddComponent, canActivate: [AuthGuard] },
  { path: 'transfer', component: DeliveryRequestTransferComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class LogisticRoutingModule {}
